import { SubscriptionClient } from 'subscriptions-transport-ws';
import { v4 as uuid4 } from 'uuid';

// Override the class SubscriptionClient to configure the websocket url that includes
// authorization data as AppSync defined in the documentation link below
// eslint-disable-next-line max-len
// https://docs.aws.amazon.com/appsync/latest/devguide/real-time-websocket-client.html#header-parameter-format-based-on-appsync-api-authorization-mode

export class CustomSubscriptionClient extends SubscriptionClient {
  constructor(url, options, getAuthorizationInfo) {
    super(url, options);
    this.getAuthorizationInfo = getAuthorizationInfo;
    this.originalUrl = url;
  }

  connect = async () => {
    // We override the method connect() to configure authorization data for the property url
    // https://github.com/apollographql/subscriptions-transport-ws/blob/master/src/client.ts#L556

    // The function this.getAuthorizationInfo() is using the method Auth.currentSession() to get authorization data
    // Notice: Auth.currentSession() will refresh the token if the accessToken is expired
    const authInfo = await this.getAuthorizationInfo();

    const headerQs = Buffer.from(JSON.stringify(authInfo)).toString('base64');
    const payloadQs = Buffer.from(JSON.stringify({})).toString('base64');
    this.url = `${this.originalUrl}?header=${headerQs}&payload=${payloadQs}`;

    super.connect();
  };

  // eslint-disable-next-line class-methods-use-this
  generateOperationId() {
    return uuid4();
  }

  processReceivedData(receivedData) {
    try {
      const parsedMessage = JSON.parse(receivedData);
      // Sent by AppSync but meaningless to us
      if (parsedMessage?.type === 'start_ack') return;
    } catch (e) {
      throw new Error(`Message must be JSON-parsable. Got: ${receivedData}`);
    }

    super.processReceivedData(receivedData);
  }
}
